import React from "react";

export default function Kafilliklar() {
  return <div>Kafilliklar</div>;
}
